module.exports = __webpack_public_path__ + "static/media/session-icon.7c12e09d.svg";